import React, {Component} from 'react';
import Avatar from "react-avatar";
import Utils from '../../common/Utils';
import {Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import PropTypes from 'prop-types';
import RoundedImageView from "../RoundedImageView/RoundedImageView";
import _ from 'lodash';

export const Components = {

    EmptyView: ({ props , onClick , round = true }) => {
        return <Avatar className="shadow-sm" round={round} size={props.size} name={props.name}/>;
    },

    ImageView: ({ props , photo , onClick }) => {
        return <RoundedImageView className="shadow-sm" onClick={onClick} src={photo.src} size={props.size}/>
    }

};

class ImageUploadComponent extends  Component{

    static propTypes = {
        size: PropTypes.number,
        name: PropTypes.string,
        enableChange: PropTypes.bool,
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
        uploadBtnOptions: PropTypes.object,
        components: PropTypes.object,
        initialImage: PropTypes.any
    };

    static defaultProps = {
       enableChange: true,
       initialImage: null
    };

    constructor(props){
        super(props);
        this.forceSelect = this.forceSelect.bind(this);
        this.state = {
            photo: _.isString(props.initialImage) ? ({ file: null , src: props.initialImage }) : props.initialImage,
            components: props.components ? _.extend(_.clone(Component),props.components) : Components
        };

    }

    getPhoto(){
        return this.state.photo;
    }

    clearPhoto(){

        this.setState({
            photo: null
        },() =>{
            this._handleChange(null);
        });

    }

    forceSelect(){

        if(this.props.enableChange)
            this._file.click();
    }

    _handleChange(file){

        if(this.props.onChange)
            this.props.onChange(file);

    }


    render(){

        const props = this.props;
        const { photo , components } = this.state;

        return  <div className="text-center">

            {photo && photo.src ? <components.ImageView onClick={this.forceSelect} photo={photo} props={props}/>  :
            <components.EmptyView onClick={this.forceSelect} props={props}/>}

            <input type="file" disabled={props.disabled} style={{ display: "none" }} ref={r => this._file = r} onChange={async e => {

                const files = e.target.files;
                if(files.length > 0){

                    //  get file
                    const file = files[0];
                    if(!Utils.validateImageFile(file))
                        return;

                    const result = await Utils.readFile(file);
                    this.setState({
                        photo: {
                            file: result.file,
                            src: result.dataURL
                        }
                    } , () => {
                        this._handleChange(file);
                    });

                }

            }}/>

            {props.enableChange && <UncontrolledDropdown style={{ marginTop: 22 }}>

                <Button color={"default"} outline={true} onClick={this.forceSelect} {...props.uploadBtnOptions}><i className="fa fa-picture-o"/> Upload Photo</Button>

                {photo && [
                    <DropdownToggle key="1" color="default" outline caret/>,
                    <DropdownMenu  key="2" flip={true}>
                        <DropdownItem onClick={() => {

                            this._file.value = null;
                            this.setState({
                                photo: null
                            },() => this._handleChange(null));

                        }}><i className="fa fa-trash"/> Remove</DropdownItem>
                    </DropdownMenu>
                ]}

            </UncontrolledDropdown>}

        </div>
    }

}

export default ImageUploadComponent;


// WEBPACK FOOTER //
// ./src/components/ImageUploadComponent/ImageUploadComponent.js